import { Logger } from '../app/utils/logger';
import { Sentry } from './sentry';
import { Swiper } from './swiper';

/**
 * Boostraping the app.
 */
class Bootstrap {
  private readonly log: Logger;
  private readonly sentry: Sentry;
  private readonly swiper: Swiper;

  /**
   * Creates an instance of Bootstrap.
   *
   * @memberof Bootstrap
   */
  constructor() {
    this.log = Logger.getInstance(Bootstrap.name);

    this.sentry = new Sentry(this.log);
    this.swiper = new Swiper(this.log);

    this.start();
  }

  /**
   * Start boostraping the app.
   *
   * @returns {void}
   */
  start(): void {
    this.sentry.init();
    this.swiper.init();
  }
}

/**
 * @description Boostrap plugins.
 * @returns {Bootstrap}
 */
export const bootstrapPlugins = (): Bootstrap => new Bootstrap();
